import tooltip from '../../components/tooltip';

const SELECTORS = {
  ATTRIBUTE_TOOLTIP: '.product-detail__attribute__value[data-tippy-content]',
};

export default () => {
  tooltip(SELECTORS.ATTRIBUTE_TOOLTIP);
};
